<template>
  <section
    :class="['searchbar', { 'location-home': isHomePath }]"
    v-if="isHomePath"
  >
    <form>
      <div class="searchbar-container">
        <label aria-label="搜尋臺南宗教藝術關鍵字" class="searchbar__label">
          <input
            ref="searchbar"
            type="text"
            title="搜尋臺南宗教藝術關鍵字"
            placeholder="請搜尋關鍵字..廟宇名稱"
            :class="[
              'searchbar__input',
              { 'searchbar__input--open': isInputOpen },
            ]"
            v-model="searchPage.params.keyword"
          />
        </label>
        <button
          class="searchbar__submit"
          type="submit"
          v-if="isHomePath"
          title="[前往]搜尋結果"
          @click="searchStart"
          @keypress="searchStart"
        >
          <img
            :src="require(`@/assets/images/navbar/light-search.svg`)"
            alt="搜尋"
            class="searchbar__submit-image"
          />
          搜尋
        </button>
        <router-link
          title="[前往]搜尋頁面"
          class="searchbar__submit"
          :to="{ name: 'searchInput' }"
          v-else
        >
          <img
            :src="require(`@/assets/images/navbar/light-search.svg`)"
            alt="搜尋"
            class="searchbar__submit-image"
          />
        </router-link>
      </div>
    </form>
  </section>
</template>

<script>
export default {
  name: 'TheSearchbar',
  props: {
    isHomePath: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isInputOpen: false,
      searchPage: {
        name: 'search',
        params: {
          keyword: '',
        },
      },
    };
  },
  computed: {},
  methods: {
    searchStart(e) {
      // 避免跳轉
      e.preventDefault();

      // 同路由並且同參數則不進行搜尋
      if (
        this.$route.name === 'search' &&
        this.$route.params.keyword === this.searchPage.params.keyword
      ) {
        return;
      }

      // 進入頁面判斷
      if (this.isHomePath) {
        // 首頁
        if (!this.searchPage.params.keyword) {
          return;
        }

        // 跳至搜尋頁面
        this.$router
          .push(JSON.parse(JSON.stringify(this.searchPage)))
          .catch(() => {});
      } else {
        // 其他頁面
        if (
          !this.isHomePath &&
          this.isInputOpen &&
          !this.searchPage.params.keyword
        ) {
          // 如果搜尋框打開，尚未輸入關鍵字
          this.isInputOpen = false;
        } else if (!this.isInputOpen && !this.searchPage.params.keyword) {
          // 如果搜尋框關閉，就打開並取得焦點
          this.isInputOpen = true;
          this.$refs.searchbar.focus();
        } else {
          // 搜尋框打開，已輸入關鍵字
          this.$router
            .push(JSON.parse(JSON.stringify(this.searchPage)))
            .catch(() => {});
        }
      }
    },
  },
  components: {},
};
</script>

<style lang="scss" scoped>
.searchbar {
  /* position: absolute;
  bottom: 5px;
  right: 0;
  text-align: center;
  width: 100%; */
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  height: 80px;
  background: url('../assets/images/search/search_bg@2x.png') center;
  background-size: cover;

  z-index: getLayerIndex(searchbar);

  @include for-tablet {
    bottom: 7px;
  }

  @include for-desktop {
    bottom: 15px;
  }

  &-container {
    position: relative;
    margin-left: auto;

    @include for-tablet {
      max-width: 523px;
    }
  }

  &__label {
    position: relative;
  }

  &__input {
    display: block;
    font-size: 14px;
    border-radius: 30px;
    border: 0;
    padding: 0;
    visibility: hidden;
    height: 0;
    width: 0;
    transition: width ease-in 300ms;
    padding: 11px 20px;
    font-size: 14px;

    &::placeholder {
      color: $color-placeholder-text;
    }

    &--open {
      width: 80%;
      height: auto;
      visibility: visible;
      padding: 0.75em 2.2em 0.75em 1.75em;
      margin-left: auto;

      @include for-tablet {
        width: 300px;
      }
    }
  }

  &__submit {
    position: absolute;
    right: 5px;
    bottom: 8px;
    padding: 0;
    width: 24px;
    cursor: pointer;
    @include button-theme(fake);

    @include for-tablet {
      right: 15px;
    }

    @include for-tablet-horizontal {
      display: none;
    }

    &:hover {
      opacity: 0.9;
    }
  }

  &__submit-image {
    display: block;
    width: 24px;
    height: 24px;
    margin-right: 3px;
  }
}

.location-home {
  left: 0;
  bottom: 20px;

  @include for-desktop {
    bottom: 70px;
  }

  .searchbar {
    &-container {
      position: relative;
      margin: auto;
    }

    &__label {
      position: relative;
    }

    &__input {
      padding: 0.75em 2.2em 0.75em 1.75em;
      visibility: visible;
      height: auto;
      border: 1px solid $color-light-border;
      width: 300px;
      height: 40px;

      @include for-tablet {
        width: 350px;
      }

      @include for-tablet-horizontal {
        max-width: 522px;
        width: 522px;
        height: 50px;
        font-size: 18px;
      }
    }

    &__submit {
      right: 3px;
      bottom: 50%;
      -webkit-transform: translate(0, 50%);
      transform: translate(0, 50%);
      // new
      width: 75px;
      height: 32px;
      display: inline-flex;
      justify-content: center;
      align-items: center;
      background: $color-light-btn-bg;
      color: $color-light-button-text;
      border-radius: 40px;
      font-family: $title-font-family;
      font-weight: 600;
      letter-spacing: 1.64px;

      @include for-tablet-horizontal {
        font-size: 18px;
        letter-spacing: 1.64px;
        padding-bottom: 2px;
        width: 94px;
        height: 40px;
        letter-spacing: 2px;
        right: 5px;
      }
    }
  }
}
</style>
